module.exports = __webpack_public_path__ + "img/02.e48b5947.png";